<ng-container *ngFor="let timeEntryCategory of timeEntryCategoriesSums">
    <nx-default-box class="bg-white border-b border-gray"
        [label]="timeEntryCategory?.category?.name">
        {{timeEntryCategory?.sum | secondsToDuration}}
    </nx-default-box>
</ng-container>
